"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteWorkOrder = void 0;
const common_1 = require("../../../common");
class CompleteWorkOrder extends common_1.UpdateAction {
}
exports.CompleteWorkOrder = CompleteWorkOrder;
//# sourceMappingURL=complete-work-order.action.js.map